import { createClient, FindOperation, getRequestFactory } from '@infuse/api/common';

export interface ChargingStationCommandResult {
  results: {
    chargingStationId: string,
    commandResult?: any,
    resultTime?: string
  }[],
  commandTime: string,
}

const client = createClient('/rest/operator-api/ocpp-command-results');

export const getChargingStationCommandResults: FindOperation<ChargingStationCommandResult, string> = getRequestFactory<
  ChargingStationCommandResult, string
>(client, {
  pattern: '/{id}',
});
